<template>
  <div class="store-detail">
    <NavHeaderBar :showSearch="false" navBarTitle="Visit & Sell-in">
      <div class="right-header" v-if="paramsUrl.pageType !== 'unassignedStore' && visitInfo.isEdit && checkPer(['admin', 'app:sdVisit:addOrUpdate'])" @click="toPage(`/salesDistribution/sdVisit?visitId=${visitInfo.id}&customerId=${visitInfo.sdId}`)">
        {{ $t('button.edit') }}
      </div>
    </NavHeaderBar>
    <div class="detail-main-content">
      <div class="mark-info"><span>{{ visitInfo.customerName }}</span></div>
      <div class="info">
        <div class="item-title">{{ $t('form.visitInfo') }}.</div>
        <div class="item-info">
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.name') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.createUserName }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.visitDate') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.visitTime }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.checkInPhoto') }}</span>
            <span class="right" v-if="visitInfo.imgMap && visitInfo.imgMap.check">
              <img class="photo-img" :src="visitInfo.imgMap.check" alt="" @click="imgPreview(0, visitInfo.imgMap.check)">
            </span>
          </div>
        </div>
      </div>
      <div class="info" v-if="showListingStatus">
        <div class="item-title">{{ $t('form.listingStatus') }}</div>
        <div class="item-info">
          <div class="top-title">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.productListingStatus') }}</div>
            </div>
          </div>
          <div class="brand-section" v-for="(brandItem, brandIndex) in visitInfo.shelfList" :key="brandIndex">
            <div class="brand-title square" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }} · {{ subItem.productName }}</span>
              <span class="custom-font">{{ subItem.isShelf === 1 ? $t('form.listing') : $t('form.notListing') }}</span>
              <span class="custom-font" :class="{'end-of-sales': subItem.isShelf === -1}">{{ subItem.isShelf === 1 ? $t('form.listing') : subItem.isShelf === 0 ? $t('form.notListing') : subItem.isShelf === -1 ? $t('form.endOfSales') : '' }}</span>
            </div>
          </div>
          <div class="top-title" v-if="isShowSd">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.listingProductSupplierDistributor') }}</div>
            </div>
          </div>
          <div class="brand-section" v-for="(brandItem, brandIndex) in visitInfo.shelfList" :key="brandIndex + 'a'">
            <div class="brand-title brand-custom-title square" v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
              <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }}</span>
            </div>
            <div class="quantity-content" v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
              <div class="qt-item jin" v-for="(detaItem, detaIndex) in brandItem.expandInfo.sdList" :key="detaIndex">
                <span>{{ detaItem.sdName }}</span>
              </div>
              <div class="qt-item jin" v-if="brandItem.expandInfo.otherSd">
                <span>{{ $t('form.other') }}：{{ brandItem.expandInfo.otherSd }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="visitInfo.totalDisposableSales || visitInfo.totalOpenSales || isShowpProjectSurveyList">
        <div class="item-title">{{ $t('shared.psi') }}</div>
        <div class="item-info">
          <div class="top-title" v-if="visitInfo.totalDisposableSales || visitInfo.totalOpenSales">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.overallSalesPerformance') }}</div>
            </div>
          </div>
          <div class="item-section" v-if="visitInfo.totalDisposableSales">
            <span class="left">{{ $t('form.totalDisposableSales') }}</span>
            <span class="right pcs-num txt-ellipsis">{{ visitInfo.totalDisposableSales }}</span>
          </div>
          <div class="item-section" v-if="visitInfo.totalOpenSales">
            <span class="left">{{ $t('form.totalOpenSystemSales') }}</span>
            <span class="right pcs-num txt-ellipsis">{{ visitInfo.totalOpenSales }}</span>
          </div>
          <div v-if="isShowpProjectSurveyList">
            <div class="top-title">
              <div class="right-title">
                <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
                <div>{{ $t('form.productSalesInventory') }}</div>
              </div>
            </div>
            <div v-for="(brandItem, brandIndex) in visitInfo.projectSurveyList" :key="brandIndex">
              <div class="brand-section" v-if="brandItem.saleQuantity || brandItem.inventoryQuantity">
                <div class="brand-title brand-custom-title square">
                  <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }}</span>
                </div>
                <div class="quantity-content">
                  <div class="qt-item jin">{{ $t('shared.salesPcsWeek') }}：<span class="custom-font">{{ brandItem.saleQuantity ? brandItem.saleQuantity : 'Unknown' }}</span></div>
                  <div class="qt-item jin">{{ $t('shared.inventoryPcs') }}：<span class="custom-font">{{ brandItem.inventoryQuantity ? brandItem.inventoryQuantity : 'Unknown' }}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="info" v-if="(visitInfo.imgMap && visitInfo.imgMap.sellIn) || isShowSellIn"> -->
      <div class="info" v-if="visitInfo.expandOrder && ![null, ''].includes(visitInfo.expandOrder.isDirect)">
        <div class="item-title">{{ $t('form.sellInByMyselfThisTime') }}</div>
        <div class="item-info">
          <!-- v-if="checkPer(['admin', 'app:sdVisit:direct'])" -->
          <div class="item-section">
            <span class="left txt-ellipsis">Direct or not：</span>
            <span v-if="!['', null].includes(visitInfo.expandOrder.isDirect)" class="right custom-font txt-ellipsis">{{ visitInfo.expandOrder.isDirect ? 'Sell-in from Acmefog' : 'Sell-in from Distributor' }}</span>
          </div>
          <div class="is-Direct" v-if="visitInfo.expandOrder.isDirect">
            <div class="top-title">
              <div class="right-title">
                <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
                <div style="color: #317bff;">Quantity sold</div>
              </div>
              <div>{{ $t('form.total') }}：<span class="custom-font">{{ totalProductQuantity }}</span> {{ $t('form.pcs') }}</div>
            </div>
            <div v-for="(brandItem, brandIndex) in visitInfo.expandOrder.productList" :key="brandIndex">
              <div class="custom-section section-quantity" v-if="brandItem.totalSpec > 0">
                <!-- :class="{'custom-collapse': !subItem.activeNames.includes('1')}" -->
                <div class="section-title square">
                  <span style="flex: 1;">{{ brandItem.projectName }}</span>
                  <span>{{ $t('form.total') }}：<span class="custom-font">{{ brandItem.totalSpec }}</span> {{ $t('form.pcs') }}</span>
                </div>
                <van-collapse v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex" v-model="subItem.activeNames" :class="{'custom-collapse': !subItem.activeNames.includes('1')}">
                  <van-collapse-item title="" name="1">
                    <template #title>
                      <div class="collapse-title">
                        <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                        <span>{{ subItem.productName }}：</span>
                        <span><span class="custom-font">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</span>
                      </div>
                    </template>
                    <div class="spec-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                      <div class="quantity-item">
                        {{ specItem.specName }}：<span>{{ specItem.quantity }}</span>
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </div>
            <div class="top-title">
              <div class="right-title">
                <img class="ell-icon" src="@/assets/images/ell_custom_icon.png" alt="">
                <div style="color: #808000;">Quantity given away</div>
              </div>
              <div>{{ $t('form.total') }}：<span class="custom-font" style="color: #808000;">{{ totalGiveProductQuantity }}</span> {{ $t('form.pcs') }}</div>
            </div>
            <div v-for="(brandItem, brandIndex) in visitInfo.expandOrder.giveProductList" :key="brandIndex + '1'">
              <div class="custom-section section-quantity" v-if="brandItem.totalSpec > 0">
                <div class="section-title custom-ection-title square">
                  <span style="flex: 1;">{{ brandItem.projectName }}</span>
                  <span>{{ $t('form.total') }}：<span class="custom-font" style="color: #808000;">{{ brandItem.totalSpec }}</span> {{ $t('form.pcs') }}</span>
                </div>
                <van-collapse v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex" v-model="subItem.activeNames" :class="{'custom-collapse': !subItem.activeNames.includes('1')}">
                  <van-collapse-item title="" name="1">
                    <template #title>
                      <div class="collapse-title">
                        <img class="jt-icon" src="@/assets/images/jt_custom_icon.png" alt="">
                        <span>{{ subItem.productName }}：</span>
                        <span><span class="custom-font" style="color: #808000;">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</span>
                      </div>
                    </template>
                    <div class="spec-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                      <div class="quantity-item custom-quantity-item">
                        {{ specItem.specName }}：<span>{{ specItem.quantity }}</span>
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="custom-section" :class="{'sell-custom-section': calculateTotalQuantity(brandItem.productList) <= 0}" v-for="(brandItem, brandIndex) in visitInfo.expandOrder.reorderList" :key="brandIndex">
              <div v-if="calculateTotalQuantity(brandItem.productList) > 0">
                <div class="section-title square">
                  <span style="flex: 1;">{{ brandItem.projectName }}</span>
                  <span class="total-desc">{{ $t('form.total') }}：<span class="custom-font">{{ calculateTotalQuantity(brandItem.productList) }}</span> {{ $t('form.pcs') }}</span>
                </div>
                <div v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                  <!-- <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                  <div>{{ subItem.productName }}：<span class="pcs-num">{{ subItem.quantity }} </span>Pcs</div> -->
                  <div class="product-item">
                    <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                    <div>{{ subItem.productName }}：<span class="custom-font">{{ calculateNum(subItem.quantity, subItem.giveQuantity) }} </span>{{ $t('form.pcs') }}</div>
                  </div>
                  <div class="section-product-sell">
                    <div class="sell-in-item">
                      <div class="quantity-item">
                        Quantity solid(Pcs)：<span>{{ subItem.quantity ? subItem.quantity : 'Unknown' }}</span>
                      </div>
                      <div class="quantity-item">
                        Quantity given away(Pcs)：<span>{{ subItem.giveQuantity ? subItem.giveQuantity : 'Unknown' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
                  <div class="product-item">
                    <img class="sd-icon" src="@/assets/images/ell_sd.png" alt="">
                    <div>{{ $t('form.brandSupplierDistributor') }}</div>
                  </div>
                  <div class="section-product-sell">
                    <div class="sell-in-item">
                      <div class="quantity-item" v-for="(sdItem, sdIndex) in brandItem.expandInfo.sdList" :key="sdIndex">
                        {{ sdItem.sdName }}
                      </div>
                      <div class="quantity-item" v-if="brandItem.expandInfo.otherSd">
                        {{ $t('form.other') }}：{{ brandItem.expandInfo.otherSd }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="visitInfo.expandOrder.isDirect">
            <!-- <div class="item-section">
              <span class="left">Order Type</span>
              <span class="right txt-ellipsis custom-font">{{ visitInfo.expandOrder.orderType }}</span>
            </div> -->
            <div class="item-section">
              <span class="left">Payment Type</span>
              <span class="right txt-ellipsis custom-font">{{ visitInfo.expandOrder.paymentType }}</span>
            </div>
            <div class="item-section">
              <span class="left">Payment Status</span>
              <span class="right txt-ellipsis custom-font">{{ visitInfo.expandOrder.paymentStatus }}</span>
            </div>
            <div class="item-section">
              <span class="left">Tax</span>
              <span class="right txt-ellipsis custom-font">{{ visitInfo.expandOrder.taxType }}</span>
            </div>
          </div>
          <div class="custom-section" v-if="visitInfo.imgMap && (visitInfo.imgMap.sellIn || visitInfo.imgMap.acmefogPhoto)">
            <div class="sell-in-photo">
              <div class="photo-item">
                <span class="item-left">{{ $t('form.photo') }}</span>
                <span v-if="visitInfo.expandOrder.isDirect" class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.acmefogPhoto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.acmefogPhoto)">
                </span>
                <span v-else class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.sellIn.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.sellIn)">
                </span>
              </div>
            </div>
          </div>
          <div v-if="historyList.length > 0" class="custom-section">
            <div class="section-title square">
              <span style="flex: 1;">{{ $t('form.orderModificationHistory') }}</span>
              <span class="total-desc" @click="toPage(`/shared/orderUpdate?sourceId=${paramsUrl.visitId}&sourceType=1&moduleType=${!visitInfo.expandOrder.isDirect ? 2 : 1}`)">More ></span>
            </div>
            <div class="history-info">
              <div class="time-name">{{ historyList[0].localCreateTime }} {{ historyList[0].createUserName }}</div>
              <div class="reason-info">
                <span class="reason-text">{{ $t('form.editReason') }}：</span>
                <span>{{ historyList[0].remark }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="isShowDisplay || visitInfo.imgMap && visitInfo.imgMap.material">
        <div class="item-title">{{ $t('form.displayMerchandising') }}</div>
        <div class="item-info">
          <div class="notes-seciton" :class="{'display-notes-section': ![true, false].includes(noticeItem.isDisplayed)}" v-for="(noticeItem, noticeIndex) in visitInfo.materielList" :key="noticeIndex">
            <div class="section-item" v-if="[true, false].includes(noticeItem.isDisplayed)">
              <span class="van-ellipsis">{{ noticeItem.materielName }}</span>
              <span class="pcs-num">{{ noticeItem.isDisplayed ? $t('shared.filter.yes') : noticeItem.isDisplayed === false ? $t('shared.filter.no') : '' }}</span>
            </div>
            <div class="notes-desc" v-if="noticeItem.remark">{{ $t('form.notes') }}：{{ noticeItem.remark }}</div>
          </div>
          <div class="custom-section" v-if="visitInfo.imgMap && visitInfo.imgMap.material">
            <div class="sell-in-photo">
              <!-- <img v-for="(subItem, subIndex) in visitInfo.imgMap.servicePhoto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt=""> -->
              <div class="photo-item">
                <span class="item-left">{{ $t('form.displayPhoto') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.material.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.material)">
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="sampleListTotal > 0 || materialListTotal > 0 || (visitInfo.imgMap && (visitInfo.imgMap.deliveryMaterialProto || visitInfo.imgMap.poPhoto))">
        <div class="item-title">{{ $t('form.materialSampleDelivery') }}</div>
        <div class="item-info is-Direct" v-if="sampleListTotal > 0">
          <div class="product-title">
            <div class="left-desc">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <span>{{ $t('form.sampleDelivery') }}</span>
            </div>
            <div class="right">{{ $t('form.total') }} <span class="pcs-num">{{ sampleListTotal }}</span> {{ $t('form.pcs') }}</div>
          </div>
          <div class="material-delivey" v-if="sampleList.length > 0">
            <div class="material-item" v-for="subItem in sampleList" :key="subItem.id">
              {{ subItem.projectName }} · {{ subItem.productName }}：{{ subItem.quantity }}
            </div>
          </div>
        </div>
        <div class="item-info is-Direct" v-if="materialListTotal > 0">
          <div class="product-title">
            <div class="left-desc">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <span>{{ $t('form.materialDelivery') }}</span>
            </div>
            <div class="right">{{ $t('form.total') }} <span class="pcs-num">{{ materialListTotal }}</span> {{ $t('form.pcs') }}</div>
          </div>
          <div class="material-delivey" v-if="putMaterielList.length > 0">
            <div class="material-item" v-for="subItem in putMaterielList" :key="subItem.id">
              {{ subItem.materielName }}：{{ subItem.quantity }}
            </div>
          </div>
        </div>
        <div class="img-content" v-if="visitInfo.imgMap && visitInfo.imgMap.deliveryMaterialProto">
          <div class="img-imgMap-left">{{ $t('form.materialSamplePhoto') }}</div>
          <div class="img-right">
            <img v-for="(subItem, subIndex) in visitInfo.imgMap.deliveryMaterialProto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.deliveryMaterialProto)">
          </div>
        </div>
        <div class="img-content" v-if="visitInfo.imgMap && visitInfo.imgMap.poPhoto">
          <div class="img-imgMap-left">{{ $t('form.poPhoto') }}</div>
          <div class="img-right">
            <img v-for="(subItem, subIndex) in visitInfo.imgMap.poPhoto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.poPhoto)">
          </div>
        </div>
      </div>
      <div class="info">
        <div class="item-title" v-if="isShowPriceList || visitInfo.competitorPrice">Distributor Price</div>
        <div class="item-info" v-if="isShowPriceList">
          <div class="top-title">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.wholesaleRetailerPurchasePrice') }}</div>
            </div>
          </div>
          <div class="brand-section" v-for="(brandItem, brandIndex) in visitInfo.priceList" :key="brandIndex">
            <div v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <div class="brand-title brand-custom-title square">
                <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }} · {{ subItem.productName }}</span>
              </div>
              <div class="quantity-content">
                <div class="qt-item jin">{{ $t('form.wholesalePurchasePrice') }}：<span class="custom-font">{{ subItem.wholesalePrice ? subItem.wholesalePrice : $t('shared.filter.unknown') }}</span></div>
                <div class="qt-item jin">{{ $t('form.retailerPurchasePrice') }}：<span class="custom-font">{{ subItem.retailPrice ? subItem.retailPrice : $t('shared.filter.unknown') }}</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="item-info">
          <div class="top-title" v-if="visitInfo.competitorPrice">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.competitorPrice') }}</div>
            </div>
          </div>
          <div class="compet-price" v-if="visitInfo.competitorPrice">{{ visitInfo.competitorPrice }}</div>
        </div>
      </div>
      <div class="info" v-if="visitInfo.feedback">
        <div class="item-title">{{ $t('shared.feedback') }}</div>
        <div class="item-info">
          <div class="item-section">
            {{ visitInfo.feedback }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sdVisitInfoApi } from '@/api/salesDistribution'
import { changeListPageApi } from '@/api/shared'
import { calculateAdd } from '@/utils/math'
import { ImagePreview, Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      paramsUrl: {},
      visitInfo: {},
      putMaterielList: [],
      sampleList: [],
      historyList: []
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.getVisitInfo()
  },
  deactivated () {
    this.$destroy()
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    totalProductQuantity () {
      if (!this.visitInfo.expandOrder || !this.visitInfo.expandOrder.productList) {
        return 0
      }
      return this.visitInfo.expandOrder.productList.reduce((acc, curr) => acc + Number(curr.totalSpec), 0)
    },
    totalGiveProductQuantity () {
      if (!this.visitInfo.expandOrder || !this.visitInfo.expandOrder.giveProductList) {
        return 0
      }
      return this.visitInfo.expandOrder.giveProductList.reduce((acc, curr) => acc + Number(curr.totalSpec), 0)
    },
    materialListTotal () {
      return this.putMaterielList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    sampleListTotal () {
      return this.sampleList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    showListingStatus () {
      if (!this.visitInfo.shelfList || !Array.isArray(this.visitInfo.shelfList)) {
        return false
      }
      return this.visitInfo.shelfList.some(brandItem =>
        brandItem.productList && brandItem.productList.some(subItem => ![null, '', undefined].includes(subItem.isShelf))
      )
    },
    isShowPriceList () {
      if (this.visitInfo.priceList && this.visitInfo.priceList.length <= 0) {
        return false
      }
      return this.visitInfo.priceList && this.visitInfo.priceList.some(brandItem => brandItem.productList.length > 0)
    },
    isShowpProjectSurveyList () {
      return this.visitInfo.projectSurveyList?.some(
        subItem => subItem.saleQuantity || subItem.inventoryQuantity
      ) || false
    },
    isShowSellIn () {
      if (!this.visitInfo.expandOrder.reorderList || this.visitInfo.expandOrder.reorderList.length === 0) {
        return false
      }
      return this.visitInfo.expandOrder.reorderList.some(brandItem => {
        return this.calculateTotalQuantity(brandItem.productList) > 0
      })
    },
    isShowDisplay () {
      if (!this.visitInfo.materielList || this.visitInfo.materielList.length === 0) {
        return false
      }
      return this.visitInfo.materielList.some(brandItem => {
        return [true, false].includes(brandItem.isDisplayed)
      })
    },
    isShowSd () {
      if (!this.visitInfo.shelfList || this.visitInfo.shelfList.length === 0) {
        return false
      }
      return this.visitInfo.shelfList.some(brandItem => {
        return brandItem.expandInfo.sdList.length > 0 || !['', null].includes(brandItem.expandInfo.otherSd)
      })
    }
  },
  methods: {
    calculateTotalQuantity (productList) {
      if (!productList || productList.length === 0) {
        return 0
      }
      return productList.reduce((total, item) => {
        return total + (Number(item.quantity) || 0)
      }, 0)
    },
    getVisitInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      sdVisitInfoApi(this.paramsUrl.visitId).then(res => {
        Toast.clear()
        const { putMaterielList, protoList, shelfList, expandOrder } = res.data
        shelfList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        expandOrder.productList.forEach(brandItem => {
          let totalSpec = 0
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
            subItem.specList = subItem.specList.filter(specItem => {
              return !['', null].includes(specItem.quantity)
            })
            totalSpec += subItem.specList.reduce((sum, specItem) => {
              return sum + (specItem.quantity ? Number(specItem.quantity) : 0)
            }, 0)
          })
          brandItem.totalSpec = totalSpec
        })
        expandOrder.giveProductList.forEach(brandItem => {
          let totalSpec = 0
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
            subItem.specList = subItem.specList.filter(specItem => {
              return !['', null].includes(specItem.quantity)
            })
            totalSpec += subItem.specList.reduce((sum, specItem) => {
              return sum + (specItem.quantity ? Number(specItem.quantity) : 0)
            }, 0)
          })
          brandItem.totalSpec = totalSpec
        })
        expandOrder.reorderList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        this.putMaterielList = putMaterielList.filter(subItem => {
          return subItem.quantity > 0
        })
        this.sampleList = protoList.filter(subItem => {
          return subItem.quantity > 0
        })
        this.visitInfo = res.data
        const data = {
          sourceId: this.paramsUrl.visitId,
          sourceType: 1,
          moduleType: !expandOrder.isDirect ? 2 : 1
        }
        changeListPageApi(data).then(res => {
          this.historyList = res.data.list
        })
      }).catch(() => {})
    },
    imgPreview (index, url) {
      ImagePreview({
        images: url.split(','),
        startPosition: index
      })
    },
    getlocation (params) {
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${params.address}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    toPage (url) {
      if (!url) {
        return
      }
      this.$router.push(url)
    },
    calculateNum (num1, num2) {
      return calculateAdd(num1, num2)
    }
  }
}
</script>

<style lang="less" scoped>
.store-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  .right-header {
    font-size: 14px;
    color: #307bff;
  }
  .right-ignore-header {
    font-size: 14px;
    color: #c4200b;
  }
  .detail-main-content {
    flex: 1;
    overflow-y: auto;
  }
  .mark-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px;
    font-weight: 700;
    color: #555;
    >span {
      font-size: 14px;
    }
    >span:nth-child(2) {
      margin-top: 5px;
    }
    .center-btn {
      padding: 2px 5px;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: 400;
      font-size: 12px;
    }
  }
  .info {
    margin-bottom: 20px;
    .item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #307bff;
      &::before {
        content: '';
        width: 6px;
        height: 12px;
        margin-right: 3px;
        background-color: #307bff;
      }
    }
    .item-info {
      padding: 0px 12px;
      .top-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        color: #333;
        font-size: 12px;
        margin-top: 10px;
        .right-title {
          display: flex;
          align-items: center;
        }
      }
      .compet-price {
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
      }
      .item-section {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .left {
          width: 200px;
          word-break: break-word;
        }
        .right {
          flex: 1;
          text-align: right;
        }
        .order-type {
          max-width: 80px;
          padding: 3px 6px;
          text-align: center;
          border: 1px solid #307bff;
          background-color: #e8effc;
          color: #307bff;
        }
        .img-right {
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
        }
        .left-num {
          width: 180px;
        }
        .address-txt {
          color: #307bff;
          text-decoration: underline;
        }
      }
      .custom-section {
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .product-item {
          display: flex;
          align-items: center;
          padding-top: 10px;
          .sd-icon {
            width: 10px;
            height: 9px;
            margin-right: 5px;
          }
        }
        .img-right {
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;
        }
        .desc-info {
          margin-top: 10px;
          color: #7f7f7f;
        }
        .section-product-name {
          padding-left: 10px;
          margin-top: 10px;
          &::before {
            content: '#';
            width: 8px;
            height: 8px;
            color: #307bff;
            margin-right: 5px;
          }
        }
        .section-product-name-bc {
          padding-top: 10px;
          padding-bottom: 10px;
          background-color: #f7f7f7;
          border-radius: 8px;
        }
        .section-product-sell {
          padding: 10px;
          background-color: #f7f7f7;
          margin-top: 8px;
          border-radius: 8px;
          .sell-in-item {
            margin-bottom: 8px;
            color: #7f7f7f;
            &:last-child {
              margin-bottom: 0;
            }
            .quantity-item {
              margin-bottom: 6px;
              &:last-child {
                margin-bottom: 0;
              }
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
        }
        .history-info {
          padding: 10px;
          margin-top: 8px;
          border-radius: 8px;
          background-color: #f7f7f7;
          color: #333;
          .time-name {
            margin-bottom: 6px;
          }
          .reason-info {
            word-break: break-word;
          }
          .reason-text {
            color: #307bff;
            font-weight: bold;
          }
        }
      }
      .sell-custom-section {
        padding: 0;
        border-bottom: none;
      }
      .notes-seciton {
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .section-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .notes-desc {
          margin-top: 10px;
          color: #7f7f7f;
        }
      }
      .display-notes-section {
        padding: 0;
        border-bottom: none;
      }
      .section-quantity {
        padding-left: 5px;
      }
      .section-title,
      .brand-title,
      .product-title {
        display: flex;
        align-items: center;
        color: #333;
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
        .total-desc {
          font-weight: 400;
        }
      }
      .custom-ection-title {
        &.square {
          &::before {
            background-color: #808000;
          }
        }
      }
      .brand-section {
        .brand-title {
          padding: 10px 0;
          border-bottom: 1px solid #e8effc;
        }
        .brand-custom-title {
          border-bottom: none;
        }
        .quantity-content {
          padding: 10px;
          background-color: #f7f7f7;
          border-radius: 8px;
          .qt-item {
            margin-bottom: 8px;
            color: #7f7f7f;
            &:last-child {
              margin-bottom: 0;
            }
            &.jin {
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
        }
      }
      .product-title {
        padding-top: 16px;
        color: #333;
        .left-desc {
          flex: 1;
          display: flex;
          align-items: center;
          font-weight: bold;
        }
      }
      .sell-in-photo {
        .photo-item {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #e8effc;
          &:last-child {
            border-bottom: none;
          }
          .item-left {
            width: 126px;
          }
          .item-right {
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
          }
        }
      }
      .img-icon {
        width: 30px;
        height: 30px;
      }
      .ell-icon {
        width: 11px;
        height: 11px;
        margin-right: 5px;
      }
      .invitation-info {
        .invitation-title {
          display: flex;
          align-items: center;
          padding-top: 16px;
          padding-bottom: 6px;
          &.square {
            font-weight: bold;
            &::before {
              content: '';
              width: 8px;
              height: 8px;
              background-color: #307bff;
              // position: absolute;
              // left: 0;
              // top: 0;
              transform: rotate(45deg);
              margin-right: 5px;
            }
          }
        }
      }
    }
    .photo-img {
      width: 60px;
      height: 60px;
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .img-content {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      padding-bottom: 0;
      .img-imgMap-left {
        width: 136px;
      }
      .img-right {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
      }
    }
    .is-Direct {
      .section-product-sell {
        margin-top: 0px !important;
      }
      .custom-section {
        padding-bottom: 5px;
        border-bottom: none;
      }
      .spec-item {
        margin-bottom: 8px;
        color: #7f7f7f;
        &:last-child {
          margin-bottom: 0;
        }
        .quantity-item {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
          &::before {
            content: '#';
            width: 8px;
            height: 8px;
            color: #307bff;
            margin-right: 5px;
          }
        }
        .custom-quantity-item {
          &::before {
            color: #808000;
          }
        }
      }
      .collapse-title {
        display: flex;
        align-items: center;
        padding: 5px 0px;
      }
      /deep/.van-collapse {
        .van-collapse-item__title {
          padding: 0;
          font-size: 12px;
          margin-bottom: 0;
        }
        .van-collapse-item__title--expanded::after {
          display: none;
        }
        .van-collapse-item__content {
          padding: 10px;
          font-size: 12px;
          background-color: #f7f7f7;
          border-radius: 10px;
        }
        .van-cell__right-icon {
          right: 10px;
          top: 5px;
        }
      }
      /deep/.van-hairline--top-bottom::after {
        display: none;
      }
      .custom-collapse {
        /deep/.van-collapse-item__title {
          border-radius: 10px;
        }
      }
    }
    .material-delivey {
      padding: 10px;
      background-color: #f7f7f7;
      margin-top: 8px;
      border-radius: 8px;
      color: #7f7f7f;
      .material-item {
        margin-bottom: 6px;
        &:last-child {
          margin-bottom: 0;
        }
        &::before {
          content: '#';
          width: 8px;
          height: 8px;
          color: #307bff;
          margin-right: 5px;
        }
      }
    }
    .delivey-total {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      margin-bottom: 6px;
    }
    .custom-font {
      font-weight: bold;
      color: #307bff;
    }
    .end-of-sales {
      color: #c4200b;
    }
  }

  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
  }
  .pcs-num {
    color: #307bff;
    font-weight: bold;
  }
  .jt-icon {
    width: 9px;
    height: 12px;
    margin-right: 5px;
  }
}
.work-dialog {
  overflow: visible;
  /deep/.van-dialog__header {
    font-weight: bold;
  }
  .close-btn-wrapper {
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
